<template>
  <div>
    <div class="policy_wrap">
      <div class="mobiSection">
        <div class="mobiSection__content">
          <div class="mobiFaq">
            <h3 class="mobiTitle sm privacy_color">Podmínky a požadavky</h3>
            <h2 class="mobiTitle sm privacy_color">Použitelnost</h2>
            <p class="mobitxt">
              Níže uvedené podmínky (Všeobecné podmínky) platí pro anglickou
              verzi jednorázově placené služby APPS4ALL Premium (Puretech Global
              Sdn Bhd a / nebo Služba) nabízené online prostřednictvím internetu
              od společnosti Puretech Global Sdn Bhd (dále jen jako Puretech
              Global Sdn Bhd). Koncový uživatel vyžaduje APPS4ALL Puretech
              Global Sdn Bhd.
            </p>
          </div>

          <div class="mobiFaq">
            <h2 class="mobiTitle sm privacy_color">Obvykle</h2>
            <p class="mobitxt">
              APPS4ALL poskytuje nejlepší sexy tapety a videa výhradně pro váš
              mobil.
            </p>
          </div>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm privacy_color">Potvrzení / registrace</h2>
            <p class="mobitxt">
              Pro přístup ke službě APPS4ALL musí koncový uživatel zadat své
              mobilní telefonní číslo a / nebo některá další data a / nebo
              informace prostřednictvím propagační webové stránky (úvodní
              stránky) provozované společností Puretech Global Sdn Bhd. Poté
              koncový uživatel obdrží na svůj server SMS mobilní zařízení, s
              osobním identifikačním číslem (PIN kód), nebo takzvanou nabídkovou
              zprávou s informacemi o službě. Koncový uživatel zadáním přijatého
              PIN kódu na úvodní stránce a / nebo odesláním potvrzovací zprávy a
              / nebo používáním služby potvrzuje a potvrzuje, že si přečetl
              Všeobecné podmínky, je autorizovaným majitelem účtu mobilního
              telefonu nebo má souhlas plátce telefonního účtu s využitím této
              služby. Koncový uživatel obdrží potvrzovací SMS zprávu o úspěšné
              aktivaci služby APPS4ALL, způsobu, frekvenci a nákladech na
              převzetí Služby a také přesné údaje o odhlášení.
            </p>
          </div>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm privacy_color">Náklady a poplatky</h2>
            <p class="mobitxt">
              APPS4ALL je placená služba, která stojí 3 SMS x 1,60 EUR / týden
              Poplatek bude účtován na účet mobilního telefonu nebo na
              předplacené mobilní číslo. Způsob účtování je Premium MT SMS
              zasílaná Koncovému uživateli na základě jeho požadavku na službu
              APPS4ALL. Tato zpráva bude obsahovat pověření služby APPS4ALL.
              Poplatky se vybírají podle provozovatelů mobilních sítí. Poplatky
              jsou odepsány na účet Koncového uživatele Provozovatelem; v
              případě SIM s předplatným jsou poplatky odečteny z kreditu
              Koncového uživatele. Koncový uživatel tímto výslovně uděluje své
              oprávnění účtovat poplatky a zavazuje se zaplatit v plné výši
              poplatky vzniklé v důsledku předplatného a / nebo používání služby
              APPS4ALL. Pokud nejste osobou odpovědnou za placení vašeho účtu za
              mobilní telefon, před přihlášením a / nebo použitím APPS4ALL si
              prosím vyžádejte povolení od svého mobilního plátce. Podpisem a /
              nebo účastí ve službě Puretech Global Sdn Bhd předpokládá, že
              koncový uživatel získal potřebné povolení, souhlas nebo schválení
              od plátce mobilního účtu, opatrovníka nebo rodičů. Všechny SMS
              zprávy zasílané koncovým uživatelem budou mobilním operátorem
              koncového uživatele účtovány za standardní tarif. Tyto sazby se
              mohou u jednotlivých operátorů lišit. Další informace o poplatcích
              vám poskytne váš mobilní operátor GSM.
            </p>
          </div>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm privacy_color">Pomoc a podpora</h2>
            <p class="mobitxt">
              Zákaznický servis je k dispozici v pracovní dny od 09:00 do 17:00
              Kontakt: +421 313215999 nebo apps4all.cz@silverlines.info
            </p>
          </div>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm privacy_color">Duševní vlastnictví</h2>
            <p class="mobitxt">
              Službu můžete používat pro osobní, nekomerční použití. Pojem
              Miximo a všechny ostatní ochranné známky, servisní značky a / nebo
              obchodní názvy používané Miximo ve Službě čas od času (ochranné
              známky) jsou ochranné známky, servisní značky a / nebo obchodní
              názvy společnosti Puretech Global Sdn Bhd nebo jedné z jejích
              společností v skupina nebo její poskytovatelé licencí a tyto
              subjekty si vyhrazují veškerá práva k ochranným známkám. Kromě
              toho patří další služby obsahu, mezi které patří mimo jiné hry,
              obrázky, obrázky, grafika, fotografie, animace, videa, hudba, zvuk
              a text, společnosti APPS4ALL nebo jedné z jejích společností a /
              nebo licencovaných skupin a jsou chráněny podle autorských práv a
              / nebo jiných práv duševního vlastnictví. Berete na vědomí, že
              používáním Služby nezískáte žádná práva na ochrannou známku ani
              Obsah Služby, než jak je uvedeno v této Smlouvě. Za žádných
              okolností nesmíte za žádných okolností kopírovat jakýkoli obsah
              služby (včetně, bez omezení, vědomostních otázek, odpovědí nebo
              her), ani ve službě používat dolování dat, roboty, škrábance na
              obrazovce nebo podobné nástroje pro sběr a extrakci dat.
              Odpovědnost Použití APPS4ALL a / nebo webových stránek APPS4ALL je
              na vlastní riziko koncového uživatele. Koncový uživatel musí
              poskytnout plně kompatibilní mobilní telefon, hardware nebo jiné
              vybavení a software a zajistit, aby byly funkční a vhodné pro
              služby APPS4ALL. APPS4ALL nemůže zaručit, že služby APPS4ALL
              splňují požadavky koncového uživatele a že stahování, přijímání a
              / nebo prohlížení služeb APPS4ALL bude nepřerušované nebo bez
              chyb. Pokud koncový uživatel kdykoli nemůže bez přerušení používat
              službu Puretech Global Sdn Bhd, nebude to v žádném případě vést k
              právu na snížení poplatků za služby APPS4ALL, k jakémukoli právu
              na vrácení předplacených plateb. Jakékoli použití Služeb APPS4ALL
              je na uvážení a riziku koncového uživatele, a to za, nikoli však
              výhradně, infekce, kontaminace nebo ztráta dat nebo poškození
              hardwaru a / nebo softwaru koncového uživatele z přístupu na Web.
              , nebo používání Služeb APPS4ALL, nebo stažených Služeb APPS4ALL,
              včetně hardwaru a softwaru nutného pro připojení ke Službám
              APPS4ALL. Je odpovědností koncových uživatelů, aby přijali
              nezbytná opatření, která zabrání možnému poškození tohoto druhu. V
              případě, že je společnost APPS4ALL z jakéhokoli důvodu povinna
              nahradit koncovému uživateli přímé nebo následné škody jakéhokoli
              druhu, nesmí taková náhrada v žádném případě překročit hodnotu
              faktury za služby APPS4ALL, kterou koncový uživatel zaplatil za
              údajné škody. Obsah webových stránek byl sestaven s největší péčí.
              APPS4ALL však nemůže poskytnout žádnou záruku, pokud jde o povahu,
              přesnost nebo obsah těchto informací. APPS4ALL nenese odpovědnost
              za chyby, opomenutí, nepřesnosti, nedorozumění, zpoždění nebo
              nečitelné objednávky nebo oznámení založená na používání internetu
              nebo příslušného informačního bodu. Závěrečná ustanovení Veškeré
              spory týkající se plnění těchto Obchodních podmínek budou řešit
              příslušné obecné soudy. Puretech Global Sdn Bhd si vyhrazuje právo
              čas od času tyto podmínky změnit. Změny budou koncovým uživatelům
              oznámeny zveřejněním na portálu APPS4ALL.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: mapGetters(["countryCode"]),
  mounted() {},
};
</script>


// WEBPACK FOOTER //
// src/components/apps4all/TermsCzech.vue